import * as React from 'react';

// Cengage Analytics CloudFront deployment inserts <base /> tag
// with CDN URL. This causes all links to be relative to that URL,
// and react-router does not support absolute paths.
// Without it, static content is not loaded properly; and static
// content must use relative paths.
// Remove <base /> tag after the content is loaded to fix links.
// PROPER SOLUTION: provide PUBLIC_URL env variable during build time,
// and not insert <base /> tag
export function useBasePathFix() {
  React.useInsertionEffect(() => {
    document.getElementsByTagName('base')[0].remove();
  }, []);
}
